import AsyncStorage from '@react-native-async-storage/async-storage';
import SecureStoreServiceBase from 'services/store/secure-store-base'

export default class SecureStoreService extends SecureStoreServiceBase {
	static async set( key, value ) {
		try {
			return await AsyncStorage.setItem( key, value );
		} catch ( e ) {}
	
		return null;
	}
	
	static async get( key ) {
		try {
			return await AsyncStorage.getItem( key );
		} catch ( e ) {}
		
		return null;
	}
	
	static async delete( key ) {
		try {
			return AsyncStorage.removeItem( key );
		} catch ( e ) {}
		
		return null;
	}
	
	static async isAvailable() {
		return true;
	}
}
